module.exports = __webpack_public_path__ + "img/vegetable-jicama-350x184.279fdff4.jpg";